import React from 'react'
import { Input } from 'sutra/components/Input/Input'

export interface AgentNameTitleProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  /** Renders Sutra's error border. */
  error?: boolean
  onBlur?: () => void
}

/** The agent name field at the top of the create/edit form. Autofocused so
 * the user can start typing the moment the screen opens. */
export const AgentNameTitle: React.FC<AgentNameTitleProps> = ({
  value,
  onChange,
  placeholder,
  error,
  onBlur,
}) => (
  <Input
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onBlur={onBlur}
    placeholder={placeholder}
    aria-label="Agent name"
    $error={error}
    autoFocus
  />
)
